<p>{{ data.message | translate }}</p>
